import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";
import { IReAppointment, IReAppointmentPage } from "../appointment/appointment.interface";
import IFilterReAppointment from "./filterReAppointment.interface";

class ReAppointmentService {
  // create
  createReAppointment(payload: IReAppointment, query?: { lang: string }) {
    return httpService.post(`${apiService.patient.reAppointment.create}`, payload, {
      params: query,
    });
  }

  // get my re-appointments
  getMyReAppointments(params?: IFilterReAppointment) {
    return httpService.get<IReAppointmentPage>(`${apiService.patient.reAppointment.getMyReAppointment}`, {
      params: {
        page_number: params?.page,
        page_size: params?.size,
      },
    });
  }

  // get by id
  getById(id: string | number) {
    return httpService.get<IReAppointment>(`${apiService.patient.reAppointment.getById}/${id}`);
  }
}

export default new ReAppointmentService();
